<div class="padding-md wrap" #wrapComponent>
  <div *ngIf="cartItems$ | async as cartItems" class="scrollable">
    <ng-container *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.DELIVERY">
      <div class="product-list">
        <div
          *ngFor="let weekNumber of weeksNumbersInOrder$ | async"
          class="by-weeks"
        >
          <div class="week-header-container">
            <div class="week-header">
              {{
                "@common.weeksByIndex." + (weekNumber | weekIndexByWeekNumber)
                  | translate
              }}
            </div>
            <div class="range">
              {{ cartService.getWeekSlotAsString(weekNumber) }}
            </div>
          </div>

          <div
            class="by-days"
            *ngFor="
              let day of cartService.getDeliveryDaysOfWeek$(weekNumber) | async
            "
          >
            <div class="header">
              <div class="day-name">
                {{ "@common.days.full." + day | translate }}
              </div>
              <div class="timeslot">
                {{ (deliveryLocation$ | async)?.workTime }}
              </div>
            </div>
            <div
              class="order-item-list"
              *ngFor="
                let item of cartItems | filterCartItemsByDay : day : weekNumber
              "
            >
              <app-order-item
                [label]="item.product.name"
                [amount]="item.quantity"
                [price]="
                  item.product
                    | getRelevantProductPrice
                    | getPrimaryCurrencyPrice
                "
              ></app-order-item>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.IN_STORE">
      <div class="product-list product-list-in-store">
        <div class="order-item-list" *ngFor="let item of cartItems">
          <app-order-item
            [label]="item.product.name"
            [amount]="item.quantity"
            [price]="
              item.product | getRelevantProductPrice | getPrimaryCurrencyPrice
            "
          ></app-order-item>
        </div>
      </div>
    </ng-container>

    <div class="info-block delivery-to">
      <ng-container *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.DELIVERY">
        <div class="header">
          {{ "@pages.orderSummary.deliveryTo.header" | translate }}
        </div>
        <div *ngIf="deliveryLocation$ | async as location" class="text">
          {{ location.name }}, {{ location.address || "..." }}
        </div>
      </ng-container>

      <ng-container *ngIf="(cart$ | async)?.orderType === ORDER_TYPES.IN_STORE">
        <div class="header">
          {{ "@pages.orderSummary.pickupFrom.header" | translate }}
        </div>
        <div *ngIf="instoreSessionLocation$ | async as location" class="text">
          {{ location.name }}, {{ location.address || "..." }}
        </div>
      </ng-container>
    </div>

    <hr class="" />

    <div class="prices">
      <!-- <div class="item">
        <div class="label">
          {{ "@pages.orderSummary.prices.promocode" | translate }}
        </div>
        <app-price-label
          [value]="1399 | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div> -->

      <!-- <div class="item">
        <div class="label">
          {{ "@pages.orderSummary.prices.subtotal" | translate }}
        </div>
        <app-price-label
          [value]="(subtotal$ | async)! | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div>

      <div class="item">
        <div class="label">
          {{ "@pages.orderSummary.prices.shipping" | translate }}
        </div>
        <app-price-label
          [value]="(shippingPrice$ | async)! | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div> -->

      <div class="item">
        <div class="label total">
          {{ "@pages.orderSummary.prices.total" | translate }}
        </div>
        <app-price-label
          [value]="(total$ | async)! | appCurrency | async"
          [noIcon]="true"
        ></app-price-label>
      </div>
    </div>
  </div>
  <div class="payment-method-select">
    <div class="header">
      {{ "@pages.orderSummary.paymentMethod.header" | translate }}
    </div>
    <app-notification-block
      class="no-methods-available"
      *ngIf="(paymentMethodOptions$ | async)?.length === 0"
      [text]="
        '@pages.orderSummary.paymentMethod.noMethodsAvailable' | translate
      "
      [style]="notificationBlockStyles.WARNING"
    >
    </app-notification-block>
    <app-radio-group
      [options]="paymentMethodOptions$ | async"
      [selectedOptionId]="selectedPaymentMethodOptionId"
      (optionSelected)="onPaymentMethodSelected($event)"
    ></app-radio-group>
    <ng-template #subsidyAmountTemplate>
      <app-price-label
        *ngIf="(clientSubsidy$ | async)?.subsidy as clientSubsidyAmount"
        [value]="clientSubsidyAmount | appCurrency | async"
        [noIcon]="true"
      ></app-price-label>
    </ng-template>
  </div>
  <div class="footer">
    <div class="actions">
      <app-action-button
        (click)="onEditClick()"
        [isOutlined]="true"
        [label]="'@pages.orderSummary.actionBtns.edit' | translate"
      ></app-action-button>
      <app-action-button
        *ngIf="
          ((userHasCard$ | async) === true &&
            selectedPaymentMethod === paymentMethods.CARD) ||
          selectedPaymentMethod !== paymentMethods.CARD
        "
        (click)="onConfirmClick()"
        [label]="'@pages.orderSummary.actionBtns.confirm' | translate"
      ></app-action-button>
      <app-action-button
        *ngIf="
          (userHasCard$ | async) === false &&
          selectedPaymentMethod === paymentMethods.CARD
        "
        (click)="onAddCreditCardClick()"
        [label]="'@pages.orderSummary.actionBtns.addCreditCard' | translate"
      ></app-action-button>
      <ion-spinner
        *ngIf="(userHasCard$ | async) === null"
        class="app-spinner"
      ></ion-spinner>
      <!-- <app-action-button
        (click)="onConfirmClick()"
        [label]="'@pages.orderSummary.actionBtns.confirm' | translate"
        [disabled]="(paymentMethodOptions$ | async)?.length === 0"
      ></app-action-button> -->
    </div>
  </div>

  <app-scroll-float-hint
    *ngIf="shouldShowScrollFloatHint"
    appScrollHint
    [appScrollHintContainerComponent]="wrapComponent"
    class="scroll-float-hint"
    (click)="scrollPageToBottom(wrapComponent)"
  ></app-scroll-float-hint>
</div>

<div *ngIf="loader.isLoading$ | async" class="loader">
  <ion-spinner class="app-spinner"></ion-spinner>
</div>
